import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import { TripListPage } from './trip-steps-list'

export const tripStepsRoutes: Route[] = [
  {
    path: Paths.TRIP_STEPS_LIST_PAGE,
    element: <TripListPage />,
    roles: [RoleEnum.ADMIN]
  }
]
